<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import HorizontalContentRow from '../components/HorizontalContentRow.vue';
import NoticeIcon from '@shared/assets/icon/danger.svg';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

function doneClickHandler() {
  router.push({ name: 'CommissionDone' });
}
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <template #title>Post-commissioning checks</template>

    <HorizontalContentRow firstRow lastRow>
      <div>
        <div class="note-container">
          <div class="icon-container">
            <NoticeIcon class="note-icon" aria-hidden="true" />
          </div>
          <div class="note-text">
            <h4 class="notice-title">Required electrical testing</h4>
            <p>
              {{ t('commissioning.postCommissionChecks.electricalTestNote') }}
            </p>
          </div>
        </div>
        <p class="step-text">
          After successfully commissioning SolShare, energise and commission inverter.
        </p>
        <div class="note-container">
          <div class="icon-container">
            <NoticeIcon class="note-icon" aria-hidden="true" />
          </div>
          <div class="note-text">
            <h4 class="notice-title">Inverter required for SolShare operation</h4>
            <p>
              Ongoing SolShare operation requires inverter to be operational. Ensure inverter is
              operational and there is a live connection between inverter and SolShare.
            </p>
          </div>
        </div>
        <p class="step-text">
          {{ t('commissioning.postCommissionChecks.solShareOperationNote') }}
        </p>
      </div>
    </HorizontalContentRow>

    <div class="button-container">
      <ButtonPrimary block @click="doneClickHandler" data-tn="done-btn"> Done </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style scoped lang="less">
.note-container {
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  border: 1px solid @color-mid-tone;
  border-radius: @border-radius-medium;
  margin-top: 1.2rem;
  padding: calc(@content-side-margin / 2);

  .icon-container {
    text-align: center;
    flex-shrink: 0;

    .note-icon {
      width: 1.8rem;
      height: 1.8rem;
    }
  }

  .note-text {
    font-size: 1rem;
    line-height: 1.4;
    color: @color-primary;
  }
}

.step-text {
  color: @color-primary;
  font-weight: @font-weight-regular;
  margin: 1.2rem 0;
  padding: 0 @content-side-margin;
}

.button-container {
  padding: 0 @content-side-margin 1.14rem;
}
</style>